import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from "@material-tailwind/react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import './index.css';
import reportWebVitals from './reportWebVitals';
import { App } from "./Code/App";
import { utils } from "./Code/Common/Controllers/Utils";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const stripePromise = loadStripe(utils.stripePublicKey);

root.render(
  // <React.StrictMode>
    <Elements stripe={stripePromise}>
      <ThemeProvider>
        <App/>
      </ThemeProvider>
    </Elements>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
